<scitis-app-global-page-header [pageTitle]="'My profile'"></scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-header">
    <span translate>Settings</span>
  </div>
  @if (user) {
    <div class="card-body">
      <table class="table vertical-align-middle mb-0 text-left">
        <thead>
          <tr>
            <th class="text-left"><span translate>Setting</span></th>
            <th class="text-left"><span translate>Value</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left"><b translate>Username</b></td>
            <td class="text-left" [innerText]="user.username"></td>
          </tr>
          <tr>
            <td class="text-left"><b translate>Name</b></td>
            <td class="text-left" [innerText]="user.displayName"></td>
          </tr>
          <tr>
            <td class="text-left"><b translate>Role</b></td>
            <td class="text-left" [innerText]="user.role"></td>
          </tr>
          <tr>
            <td class="text-left"><b translate>Organization</b></td>
            <td class="text-left" [innerText]="getOrganization()"></td>
          </tr>
          <tr>
            <td class="text-left"><b translate>Notification retention</b></td>
            <td class="text-left">
              <form [formGroup]="notificationRetentionForm">
                <div class="input-group mb-0" style="max-width: 150px">
                  <input [ngClass]="{ 'is-invalid': formControls.notificationRetentionDays.errors }"
                    formControlName="notificationRetentionDays" id="notificationRetentionDays"
                    name="notificationRetentionDays"
                    type="number" class="form-control" placeholder="XY"
                    (change)="notificationRetentionDaysChanged()">
                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon2" translate>Days</span>
                    </div>
                    @if (formControls.notificationRetentionDays.errors) {
                      <div
                        class="invalid-feedback">
                        @if (formControls.notificationRetentionDays.errors.min) {
                          <span
                          translate>Value must be at least 1!</span>
                        }
                        @if (formControls.notificationRetentionDays.errors.max) {
                          <span
                          [innerHTML]="maxExceededMessage"></span>
                        }
                        @if (formControls.notificationRetentionDays.errors.required) {
                          <span
                          translate>The value is not a number!</span>
                        }
                      </div>
                    }
                  </div>
                </form>
              </td>
            </tr>
            <tr class="border-bottom-0">
              <td class="text-left border-bottom-0"><b translate>Password</b></td>
              <td class="text-left border-bottom-0">
              @if (showChangePassword) {
                  <button class="btn btn-outline-primary" (click)="openChangePasswordModal()">
                    <span class="fa-solid fa-key mr-1"></span>
                    <span translate>Change password</span>
                  </button>
              }
              @if (managePassword) {
                  <a [href]="ssoProfileLink" class="btn btn-outline-primary" target="_blank" [ngbTooltip]="managePasswordTooltip">
                    <span class="fa-solid fa-key mr-1"></span>
                    <span translate>Manage password</span>
                  </a>
              }
              </td>
            </tr>
        </tbody>
      </table>
      </div>
    }
    <div class="card-footer d-flex justify-content-end">
      <button class="btn btn-primary ml-2" [disabled]="saveButtonIsDisabled"
        (click)="saveNotificationRetention()" translate>Save changes
      </button>
    </div>
  </div>
  @if (!isViewerRole) {
    <div class="card">
      <div class="card-header">
        <span translate>Organization specific values</span>
        @if (isLoadingConstants) {
          <span class="fa-solid fa-spinner fa-spin ml-2"></span>
        }
      </div>
      <div class="card-body">
        @for (constant of organizationConstants; track constant) {
          <div>
            <div class="d-flex align-items-center mb-2">
              <h5 class="mb-0" [innerHTML]="constant.portalSetting.name"></h5> <span
            class="badge badge-outline badge-primary ml-2" [innerHTML]="constant.portalSetting.value"></span>
          </div>
          <table class="table table-sm mb-3 vertical-align-middle text-left">
            <thead>
              <tr>
                <th class="col-4 text-left" translate>Value</th>
                <th class="col-4 text-left" translate>Start</th>
                <th class="col-4 text-left" translate>End</th>
              </tr>
            </thead>
            <tbody>
              @for (constantValue of getOrderedConstantValues(constant.tenantConstant.constantValues); track constantValue; let last = $last) {
                <tr
                  [ngClass]="[getConstantValueClass(constantValue), last ? 'border-bottom-0' : '']">
                  <td class="text-left" [class.border-bottom-0]="last" [innerHTML]="getValueAnUnit(constant, constantValue)"></td>
                  <td class="text-left" [class.border-bottom-0]="last" [innerHTML]="constantValue.startTimestamp | date:'dd.MM.yyyy'"></td>
                  <td class="text-left" [class.border-bottom-0]="last" [innerHTML]="constantValue.endTimestamp | date:'dd.MM.yyyy'"></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
}
